// extracted by mini-css-extract-plugin
export var closeButton = "_ev-1";
export var closeX = "_ev-3";
export var container = "_ev-0";
export var image = "_ev-2";